const namespaced = true;

const state = {
  items: []
};

const getters = {
  items: state => state.items
};

const mutations = {
  SET_ITEM: (state, payload) => {
    state.items = payload;
  }
};

const actions = {
  // eslint-disable-next-line no-unused-vars
  async getFileNameClassroom({ commit }, filename) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/export/assignment-group?fileName=${filename}`);
      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  async getFileNameClassroomDua({ commit }, { classId, courseId }) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/export/classroom/${classId}/course/${courseId}/assignment-groups`);
      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  download({ commit }, { classId, courseId, classSectionId }) {
    let url;
    if (!classSectionId) {
      url = `/api/export/classroom/${classId}/course/${courseId}`;
    } else {
      url = `/api/export/class-section/${classSectionId}`;
    }
    return window.axios.get(`${url}`, { responseType: 'arraybuffer' });
  },
  // eslint-disable-next-line no-unused-vars
  async attach({ commit }, payload) {
    const formData = new FormData();
    Object.keys(payload).forEach(p => formData.append(p, payload[p]));
    let url;
    if (!payload.classSectionId) {
      url = `/api/export/classroom/${payload.classId}/course/${payload.courseId}`;
    } else {
      url = `/api/export/class-section/${payload.classSectionId}`;
    }
    let res = await window.axios.post(`${url}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    return res.data;
  },
  // eslint-disable-next-line no-unused-vars
  statusCodeSatu({ rootGetters }, payload) {
    const formData = new FormData();
    Object.keys(payload).forEach(p => formData.append(p, payload[p]));
    const { classroomId, courseId } = payload;
    return window.axios.post(`api/export/classroom/${classroomId}/course/${courseId}/move`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  },
  // eslint-disable-next-line no-unused-vars
  statusCodeDua({ rootGetters }, payload) {
    const formData = new FormData();
    Object.keys(payload).forEach(p => formData.append(p, payload[p]));
    const { classroomId, courseId } = payload;
    return window.axios.post(`api/export/classroom/${classroomId}/course/${courseId}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  }
};

export default { namespaced, state, getters, mutations, actions };
